export default __webpack_public_path__ + "static/media/search.42acc71f.svg";